import { render } from "./EmbeddedBoard.vue?vue&type=template&id=39636748&scoped=true&ts=true"
import script from "./EmbeddedBoard.vue?vue&type=script&lang=ts"
export * from "./EmbeddedBoard.vue?vue&type=script&lang=ts"

import "./EmbeddedBoard.vue?vue&type=style&index=0&id=39636748&scoped=true&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39636748"]])

export default __exports__